import React from 'react';

import { colors } from 'helpers/colors';

function SvgWalletSolid({ size = 30, color = colors.gray[700] }) {
  return (
    <svg width={size} viewBox="0 0 32 29" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M7.66667 7.66667H12.6667M27.6667 21H24.3333C22.7617 21 21.9767 21 21.4883 20.5117C21 20.0233 21 19.2383 21 17.6667C21 16.095 21 15.31 21.4883 14.8217C21.9767 14.3333 22.7617 14.3333 24.3333 14.3333H27.6667C29.2383 14.3333 30.0233 14.3333 30.5117 14.8217C31 15.31 31 16.095 31 17.6667C31 19.2383 31 20.0233 30.5117 20.5117C30.0233 21 29.2383 21 27.6667 21ZM27.6667 27.6667H4.33333C3.44928 27.6667 2.60143 27.2344 1.97631 26.4651C1.35119 25.6957 1 24.6522 1 23.5641V5.10256C1 4.0145 1.35119 2.97099 1.97631 2.20161C2.60143 1.43223 3.44928 1 4.33333 1H27.6667C28.5507 1 29.3986 1.43223 30.0237 2.20161C30.6488 2.97099 31 4.0145 31 5.10256V23.5641C31 24.6522 30.6488 25.6957 30.0237 26.4651C29.3986 27.2344 28.5507 27.6667 27.6667 27.6667Z" stroke={color} strokeWidth="2" strokeLinecap="round"/>
    </svg>
  );
}

export default SvgWalletSolid;
